export default __webpack_public_path__ + "61499380d7dcfb0330028be7334f0421.png";